import {
    Box,
    DialogActions,
    DialogContent,
    DialogTitle,
    Skeleton,
    Typography
} from "@mui/material";

export default function DSNSummarySkeleton() {
  return (
    <Box>
      <DialogTitle>
        <Skeleton width={200} height={25} />
      </DialogTitle>

      <DialogContent dividers>
        <Box display="flex" gap={2} mb={2}>
          <Skeleton variant="rectangular" width={100} height={25} />
          <Skeleton variant="rectangular" width={150} height={25} />
          <Skeleton variant="rectangular" width="60%" height={25} />
        </Box>

        <Typography variant="subtitle2" gutterBottom>
          <Skeleton width={180} height={18} />
        </Typography>

        {[1,2,3].map((row) => (
          <Box
            key={row}
            mb={2}
            display="flex"
            flexDirection="column"
            gap={1}
            p={1}
            border="1px solid #ddd"
            borderRadius={2}
          >
            <Skeleton width={120} height={18} />
            <Skeleton width={80} height={18} />
            <Skeleton width="90%" height={50} />
          </Box>
        ))}
      </DialogContent>

      <DialogActions>
        <Skeleton variant="rectangular" width={80} height={30} />
      </DialogActions>
      </Box>
  );
}
